import { render, staticRenderFns } from "./ChallengeCreateView.vue?vue&type=template&id=60295a74&scoped=true&"
import script from "./ChallengeCreateView.vue?vue&type=script&lang=js&"
export * from "./ChallengeCreateView.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeCreateView.vue?vue&type=style&index=0&id=60295a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60295a74",
  null
  
)

/* custom blocks */
import block0 from "./ChallengeCreateView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports